import * as React from "react"

import { MoveHandle } from "Catalog/Edit/shared/components/Navigator"
import { ItemRenderProps } from "Catalog/Edit/shared/components/Navigator/types"
import useEditor from "shared/hooks/useEditor"
import { ICategory } from "shared/hubrise/models"
import { Category } from "shared/hubrise/utils"

import { StyledCategory, Name } from "./Styles"

interface ItemCategoryProps {
  category: ICategory
  itemRenderProps: ItemRenderProps
}

const ItemCategory = ({ category, itemRenderProps }: ItemCategoryProps): JSX.Element => {
  const { catalog } = useEditor()

  return (
    <StyledCategory {...itemRenderProps}>
      <Name>
        {Category.ancestors(catalog, category).map(({ name: ancestorName }, index) => (
          <span key={index}>{ancestorName}</span>
        ))}
        {category.name}
      </Name>

      <MoveHandle {...itemRenderProps} />
    </StyledCategory>
  )
}

export default ItemCategory
